<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-world bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("website.website-whois-search") }}</h5>
            </div>
          </div>
          <div class="row mt-5 mb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  v-on:input="removeHttp(searchKey)"
                  placeholder="domainname.com"
                  aria-describedby="search"
                  @keyup.enter="searchWebsite"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchWebsite"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              >
                <span class="sr-only"
                  ><p>{{ $t("website.website-location") }}</p></span
                >
              </div>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading && !SearchResult.domainName"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>

          <div
            v-if="!SearchResult.domainName && !loading && search && error == ''"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>
          <div>
            <div class="card mt-0" v-if="SearchResult.domainName">
              <p v-if="SearchResult.domainName">
                <b>{{ $t("website.domain_name") }}: </b>
                {{ SearchResult.domainName }}
              </p>
              <p v-if="SearchResult.createdDate">
                <b>{{ $t("website.created_date") }}: </b>
                {{ formatDate(SearchResult.createdDate) }}
              </p>
              <p v-if="SearchResult.expiresDate">
                <b>{{ $t("website.expired_date") }}: </b>
                {{ formatDate(SearchResult.expiresDate) }}
              </p>
              <p v-if="SearchResult.contact_email">
                <b>{{ $t("website.contact_email") }}: </b>
                {{ SearchResult.contact_email }}
              </p>
              <p v-if="SearchResult.registrant_name">
                <b>{{ $t("website.registran_name") }}: </b>
                {{ SearchResult.registrant_name }}
              </p>
              <p v-if="SearchResult.registrant_organization">
                <b>{{ $t("website.registrant_organization") }}: </b>
                {{ SearchResult.registrant_organization }}
              </p>
              <p v-if="SearchResult.registrant_street">
                <b>{{ $t("website.registran_street") }}: </b>
                {{ SearchResult.registrant_street }}
              </p>
              <p v-if="SearchResult.registrant_city">
                <b>{{ $t("website.registran_city") }}: </b>
                {{ SearchResult.registrant_city }}
              </p>
              <p v-if="SearchResult.registrant_state">
                <b>{{ $t("website.registran_state") }}: </b>
                {{ SearchResult.registrant_state }}
              </p>
              <p v-if="SearchResult.registrant_postalCode">
                <b>{{ $t("website.registran_postal_code") }}: </b>
                {{ SearchResult.registrant_postalCode }}
              </p>
              <p v-if="SearchResult.registrant_host_contry">
                <b>{{ $t("website.registran_country") }}: </b>
                {{ SearchResult.registrant_host_contry }}
              </p>
              <p v-if="SearchResult.registrant_countryCode">
                <b>{{ $t("website.registran_country") }}: </b>
                {{ SearchResult.registrant_countryCode }}
              </p>
              <p v-if="SearchResult.registrant_email">
                <b>{{ $t("website.registran_email") }}: </b>
                {{ SearchResult.registrant_email }}
              </p>
              <p v-if="SearchResult.registrant_telephone">
                <b>{{ $t("website.registran_phone") }}: </b>
                {{ SearchResult.registrant_telephone }}
              </p>
              <p v-if="SearchResult.registrant_fax">
                <b>{{ $t("website.registran_fax") }}: </b>
                {{ SearchResult.registrant_fax }}
              </p>
              <p v-if="SearchResult.admin_name">
                ======================================================
              </p>
              <p v-if="SearchResult.admin_name">
                <b>{{ $t("website.admin_name") }}: </b>
                {{ SearchResult.admin_name }}
              </p>
              <p v-if="SearchResult.admin_organization">
                <b>{{ $t("website.admin_organization") }}: </b>
                {{ SearchResult.admin_organization }}
              </p>
              <p v-if="SearchResult.admin_street">
                <b>{{ $t("website.admin_street") }}: </b>
                {{ SearchResult.admin_street }}
              </p>
              <p v-if="SearchResult.admin_city">
                <b>{{ $t("website.admin_city") }}: </b>
                {{ SearchResult.admin_city }}
              </p>
              <p v-if="SearchResult.admin_state">
                <b>{{ $t("website.admin_state_provincie") }}: </b>
                {{ SearchResult.admin_state }}
              </p>
              <p v-if="SearchResult.admin_postalCode">
                <b>{{ $t("website.admin_postal_code") }}: </b>
                {{ SearchResult.admin_postalCode }}
              </p>
              <p v-if="SearchResult.admin_host_contry">
                <b>{{ $t("website.admin_country") }}: </b>
                {{ SearchResult.admin_host_contry }}
              </p>
              <p v-if="SearchResult.admin_countryCode">
                <b>{{ $t("website.admin_postal_code") }}: </b>
                {{ SearchResult.admin_countryCode }}
              </p>
              <p v-if="SearchResult.admin_email">
                <b>{{ $t("website.admin_phone") }}: </b>
                {{ SearchResult.admin_email }}
              </p>
              <p v-if="SearchResult.admin_telephone">
                <b>{{ $t("website.admin_phone") }}: </b>
                {{ SearchResult.admin_telephone }}
              </p>
              <p v-if="SearchResult.admin_fax">
                <b>{{ $t("website.admin_fax") }}: </b>
                {{ SearchResult.admin_fax }}
              </p>
              <p v-if="SearchResult.tech_name">
                ======================================================
              </p>
              <p v-if="SearchResult.tech_name">
                <b>{{ $t("website.tech_name") }}: </b>
                {{ SearchResult.tech_name }}
              </p>
              <p v-if="SearchResult.tech_organization">
                <b>{{ $t("website.tech_organization") }}: </b>
                {{ SearchResult.tech_organization }}
              </p>
              <p v-if="SearchResult.tech_street">
                <b>{{ $t("website.tech_street") }}: </b>
                {{ SearchResult.tech_street }}
              </p>
              <p v-if="SearchResult.tech_city">
                <b>{{ $t("website.tech_city") }}: </b>
                {{ SearchResult.tech_city }}
              </p>
              <p v-if="SearchResult.tech_state">
                <b>{{ $t("website.tech_state_province") }}: </b>
                {{ SearchResult.tech_state }}
              </p>
              <p v-if="SearchResult.tech_postalCode">
                <b>{{ $t("website.tech_postal_code") }}: </b>
                {{ SearchResult.tech_postalCode }}
              </p>
              <p v-if="SearchResult.tech_host_contry">
                <b>{{ $t("website.tech_country") }}: </b>
                {{ SearchResult.tech_host_contry }}
              </p>
              <p v-if="SearchResult.tech_countryCode">
                <b>{{ $t("website.tech_postal_code") }}: </b>
                {{ SearchResult.tech_countryCode }}
              </p>
              <p v-if="SearchResult.tech_email">
                <b>{{ $t("website.tech_email") }}: </b>
                {{ SearchResult.tech_email }}
              </p>
              <p v-if="SearchResult.tech_telephone">
                <b>{{ $t("website.tech_phone") }}: </b>
                {{ SearchResult.tech_telephone }}
              </p>
              <p v-if="SearchResult.tech_fax">
                <b>{{ $t("website.tech_fax") }}: </b>
                {{ SearchResult.tech_fax }}
              </p>
              <div class="col-sm-12 text-right">
                <b-button
                  class="btn"
                  variant="secondary"
                  size="sm"
                  @click="clearData"
                  ><i class="fa fa-times"></i>
                  {{ $t("website.clear") }}</b-button
                >
                <b-button
                  class="btn ml-2"
                  variant="success"
                  size="sm"
                  @click="saveWhois"
                  ><i class="fa fa-check"></i>
                  {{ $t("website.save") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-sm-6">
        <h5>{{ $t("website.list_web_whois") }}</h5>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;
                  </label>
                  {{ $t("all.entries") }}
                  <b-button
                    class="btn btn-sm ml-2"
                    variant="danger"
                    @click="bulkAction()"
                    v-if="selected[0]"
                    >{{ $t("button.bulk") }}: {{ selected.length }}
                    {{ $t("button.row-data") }}</b-button
                  >
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk) width="4%">
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(bulk)="row" width="4%">
                  <b-form-checkbox
                    class="text-center mt-0"
                    v-model="selected"
                    :value="row.item.id_whois"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(created_date)="row">
                  <p class="text-secondary">
                    {{ formatDate(row.item.created_date) }}
                  </p>
                </template>
                <template #cell(expired_date)="row">
                  <p class="text-secondary">
                    {{ formatDate(row.item.expired_date) }}
                  </p>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'website-whois-detail',
                      params: { id: row.item.id_whois },
                    }"
                    ><b-button class="mr-1 btn-sm mb-1" variant="secondary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></router-link>
                  <b-button
                    class="mr-0 btn-sm mb-1"
                    variant="danger"
                    @click="deleteWebInfoWhois(row.item.id_whois)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>
              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!loadingInfo && rows > 10">
                <div class="col-2 col-xl-1">
                    <!-- <div v-if="selected[0]">
                    <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                    <label class="d-inline-flex align-items-center">
                    Page
                    <b-form-input
                        v-model="currentPage"
                        placeholder="Page"
                        class="form-control w-10 form-control ml-2"
                    ></b-form-input>
                    </label>
                </div>
                <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";


export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      pref_search: {
          api_host:"",
          x_rapidapi_host:"",
          x_rapidapi_key:"",
      },
      loading: false,
      loadingInfo: false,
      error: "",
      search: false,
      searchKey: "",
      SearchResult:{
        domainName:"",
        createdDate:"",
        expiresDate:"",
        contact_email:"" ,
        registrant_name:"",
        registrant_organization:"",
        registrant_street:"",
        registrant_city:"",
        registrant_state:"",
        registrant_postalCode:"",
        registrant_host_contry:"",
        registrant_email:"",
        registrant_telephone:"",
        registrant_fax:"",
      },
    
      total_results: "",
      tableData: [],
      selected: [],
      selectAll: false,
      is_spam: "",
      search: false,
      title: this.$t("website.website-whois"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("website.website-whois"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        { key: "id_whois", thClass: "d-none", tdClass: "d-none" },
        {
          key: "domain_name",
          label: this.$t("website.domain_name"),
          sortable: true,
        },
        { key: "created_date", label: this.$t("website.created_date") },
        { key: "expired_date", label: this.$t("website.expired_date") },
        {
          key: "registran_country",
          label: this.$t("website.registran_country"),
          sortable: true,
        },
        {
          key: "registran_organization",
          label: this.$t("website.registrant_organization"),
          sortable: true,
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "10%" },
          label: this.$t("website.actions"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_whois);
        }
      }
    },
    searchWebsite() {
      this.error = "";
      this.loading = true;
      this.search = true;
      const data = {
        website: this.searchKey,
      };
      WebsiteService.searchDomainWhois(data)
        .then((response) => {
          this.SearchResult = {
              domainName:"",
              createdDate:"",
              expiresDate:"",
              contact_email:"" ,
              registrant_name:"",
              registrant_organization:"",
              registrant_street:"",
              registrant_city:"",
              registrant_state:"",
              registrant_postalCode:"",
              registrant_host_contry:"",
              registrant_email:"",
              registrant_telephone:"",
              registrant_fax:"",
            },
          // this.SearchResult = response.data.output;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.searchWhois(this.searchKey);
          if (err.response.status == 500) {
            this.error = this.$t("all.error-500");
          } else if (err.response.status == 404) {
            this.error = this.$t("all.error-404");
          }
        });
    },

    getPreferencesSearch() {
        let id = 63;
        PreferenceService.getRapidApiByID(id)
        .then((response) => {
           // console.log(response.data.data);
            // this.pref = response.data.data;
            this.pref_search.api_host = response.data.data.api_host;
            this.pref_search.x_rapidapi_host = response.data.data.api_header_host;
            this.pref_search.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
            console.log(err);
        });
    },    
      
    searchWhois(key) {
          if (this.searchKey != "") {
              let headers = {
                  'content-type': 'application/json',
                  'x-rapidapi-host': this.pref_search.x_rapidapi_host,
                  'x-rapidapi-key': this.pref_search.x_rapidapi_key
              };
              console.log(headers);
              return axios.get(this.pref_search.api_host+'?search='+key, { headers: headers })
                .then((response) => {
                    console.log('whois', response.data);
                    let val = response.data;
                    this.SearchResult.domainName = val["Domain Name"] ?? val["Domain Name"];
                    this.SearchResult.createdDate = val["Creation Date"] ?? val["Created On"];
                    this.SearchResult.expiresDate = val["Registry Expiry Date"] ?? val["Expiration Date"];
                    this.SearchResult.contact_email = val["Registrar Abuse Contact Email"] ?? '';
                    this.SearchResult.registrant_name = val["Registrar"] ?? '';
                    this.SearchResult.registrant_organization = val["Sponsoring Registrar Organization"] ?? '';
                    this.SearchResult.registrant_street = val["Sponsoring Registrar Street"] ?? '';
                    this.SearchResult.registrant_city = val["Sponsoring Registrar State/Province"] ?? '';
                    this.SearchResult.registrant_state = val["Sponsoring Registrar State/Province"] ?? '';
                    this.SearchResult.registrant_postalCode = val["Sponsoring Registrar Postal Code"] ?? '';
                    this.SearchResult.registrant_host_contry = val["Sponsoring Registrar Country"] ?? '';
                    this.SearchResult.registrant_email = val["Sponsoring Registrar Email"] ?? val["Registrar Abuse Contact Email"];
                    this.SearchResult.registrant_telephone = val["Sponsoring Registrar Phone"] ?? val["Registrar Abuse Contact Phone"];
                    this.SearchResult.registrant_fax = val["Sponsoring Registrar Fax"] ?? '';
                    this.loading = false;
                })
              .catch((err) => {
                  console.log(err);   
                  this.loading = false;
              });
          }
        },

    saveWhois() {
      this.loadingsave = true;
      var data = {
        domain_name: this.SearchResult.domainName,
        created_date: this.SearchResult.createdDate,
        expired_date: this.SearchResult.expiresDate,
        contact_email: this.SearchResult.contact_email,
        registran_name: this.SearchResult.registrant_name,
        registran_organization: this.SearchResult.registrant_organization,
        registran_street: this.SearchResult.registrant_street,
        registran_city: this.SearchResult.registrant_city,
        registran_state: this.SearchResult.registrant_state,
        registran_postal_code: this.SearchResult.registrant_postalCode,
        registran_country: this.SearchResult.registrant_host_contry,
        registran_email: this.SearchResult.registrant_email,
        registran_phone: this.SearchResult.registrant_telephone,
        registran_fax: this.SearchResult.registrant_fax,
        admin_name: this.SearchResult.admin_name,
        admin_organization: this.SearchResult.admin_organization,
        admin_street: this.SearchResult.admin_street,
        admin_city: this.SearchResult.admin_city,
        admin_state_province: this.SearchResult.admin_city,
        admin_postal_code: this.SearchResult.admin_postalCode,
        admin_country: this.SearchResult.admin_countryCode,
        admin_email: this.SearchResult.admin_email,
        admin_phone: this.SearchResult.admin_telephone,
        admin_fax: this.SearchResult.admin_fax,
        tech_name: this.SearchResult.tech_name,
        tech_organization: this.SearchResult.tech_organization,
        tech_street: this.SearchResult.tech_street,
        tech_city: this.SearchResult.tech_city,
        tech_state_province: this.SearchResult.tech_state,
        tech_postal_code: this.SearchResult.tech_postalCode,
        tech_country: this.SearchResult.tech_host_contry,
        tech_email: this.SearchResult.tech_email,
        tech_phone: this.SearchResult.tech_telephone,
        tech_fax: this.SearchResult.tech_fax,
      };
      console.log();
      WebsiteService.createWebWhois(data)
        .then((response) => {
          Swal.fire(response.data.message, "", "success");
          this.getWebsiteInfoWhoisUpdate();
          this.loading = false;
          this.searchKey = "";
          this.SearchResult = "";
          this.search = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.search = false;
        });
    },

    getWebsiteInfoWhois() {
      this.loadingInfo = true;
      WebsiteService.getWebWhois()
        .then((response) => {
          this.tableData = [];
          this.loadingInfo = false;
          response.data.data.forEach((val, index) => {
            const data = {
              no: index+1,
              id_whois: val.id_whois,
              domain_name: val.domain_name,
              created_date: val.created_date,
              expired_date: val.expired_date,
              registran_country: val.registran_country ?? "-",
              registran_organization: val.registran_organization ?? "-",
            };
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
        })
        .catch((err) => {
          this.loadingInfo = false;
          console.log(err);
        });
    },


    getWebsiteInfoWhoisUpdate() {
      WebsiteService.getWebWhois()
        .then((response) => {
          this.tableData = [];
          this.loadingInfo = false;
          response.data.data.forEach((val, index) => {
            const data = {
              no: index+1,
              id_whois: val.id_whois,
              domain_name: val.domain_name,
              created_date: val.created_date,
              expired_date: val.expired_date,
              registran_country: val.registran_country ?? "-",
              registran_organization: val.registran_organization ?? "-",
            };
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
        })
        .catch((err) => {
          this.loadingInfo = false;
          console.log(err);
        });
    },
    deleteWebInfoWhois(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          WebsiteService.deleteWebWhois(id)
            .then((response) => {
              this.getWebsiteInfoWhois();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          WebsiteService.websiteBulkWebWhois(data)
            .then((response) => {
              this.selected = [];
              this.getWebsiteInfoWhois();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    removeHttp(url) {
      let x = url
        .replace(/(^\w+:|^)\/\//, "")
        .replace("/", "")
        .replace("www.", "");
      return (this.searchKey = x);
    },
    clearData() {
      this.SearchResult = "";
      this.searchKey = "";
      this.search = false;
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getWebsiteInfoWhois();
    this.getPreferencesSearch();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>

